import { departmentsSection } from '@stereoagency/sanity-schema';

type Departments = NonNullable<
  (typeof departmentsSection.schema.departmentsSection)['departments']
>;

export default function extractAllProfilesFromDepartments(
  departments: Departments
) {
  const profileIds =
    departments?.reduce<string[]>((acc, department) => {
      if (
        department.primaryMembers?.length ||
        department.otherMembers?.length
      ) {
        const allMembers = [
          ...(department.primaryMembers ?? []),
          ...(department.otherMembers ?? [])
        ];
        for (const member of allMembers) {
          if (member.profile?._ref) {
            acc.push(member.profile._ref);
          }
        }
      }
      return acc;
    }, []) ?? [];
  return profileIds;
}
